import { headers } from '../common'

async function getListData(param) {
  const queryParams = new URLSearchParams(param);

  return fetch('/api/staff?' + queryParams)
        .then(res => {
          return res;
        })
        .catch(errors => {
          return errors;
        })
}

async function getPointAndMoney(staff_id, param) {
  const queryParams = new URLSearchParams(param);

  return fetch('/api/staff/' + staff_id + '/get-point-money?' + queryParams)
        .then(res => {
          return res;
        })
        .catch(errors => {
          return errors;
        })
}

async function checkUniqueStaff(staff_id, param, partner_id) {

  return fetch('/api/staff/' + staff_id + '/check-unique', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({"login_id": param, "id": partner_id}),
  }).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { getListData, getPointAndMoney, checkUniqueStaff }
